import { render, staticRenderFns } from "./BrandConvertSuccessView.vue?vue&type=template&id=b9dfa76c&scoped=true&"
import script from "./BrandConvertSuccessView.vue?vue&type=script&lang=js&"
export * from "./BrandConvertSuccessView.vue?vue&type=script&lang=js&"
import style0 from "./BrandConvertSuccessView.vue?vue&type=style&index=0&id=b9dfa76c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dfa76c",
  null
  
)

export default component.exports